/** 停车资源分布 */
import ReactEcharts from 'echarts-for-react';
import React from 'react'
import Panel from '../index'
export interface ParkikngResourceProps {
  areaCode?: string
}
const ParkikngResource: React.FC<ParkikngResourceProps> = () => {

/**图表数据 */
const chartData = [
  { name: '路段(条)', value: 29 },
  { name: '道路车位(个)', value: 3255 },
  { name: '车场(个)', value: 1 },
  { name: '车场车位(个)', value: 22 }
]

const barColors = [
  ['#00ccff', 'rgba(0, 204, 255, 0.15)'],
  ['#6772ff', 'rgba(103, 114, 255, 0.15)'],
  ['#2dbcdf', 'rgba(45, 189, 223, 0.15)'],
  ['#4aa3e2', 'rgba(74, 163, 226, 0.15)']
]

let Option = {
  tooltip: {
    trigger: 'axis',
    axisPointer: { type: 'shadow' }
  },
  grid: {
    left: 10,
    right: 10,
    top: 30,
    bottom: 0,
    containLabel: true
  },
  xAxis: {
    type: 'category',
    data: chartData.map(item => item.name),
    axisTick: { show: false },
    axisLine: {
      lineStyle: { color: 'rgba(32, 188, 252, 0.4)' }
    },
    axisLabel: {
      color: 'rgba(32, 188, 252, 1)',
      fontSize: 11,
      interval: 0
    }
  },
  yAxis: {
    type: 'value',
    axisLabel: { color: 'rgba(32, 188, 252, 1)' },
    splitLine: {
      lineStyle: { color: 'rgba(32, 188, 252, 0.15)', type: 'dashed' }
    }
  },
  series: [
    {
      type: 'bar',
      barWidth: 24,
      label: {
        show: true,
        position: 'top',
        color: 'rgba(32, 188, 252, 1)'
      },
      data: chartData.map((item, index) => ({
        value: item.value,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: barColors[index][0] },
              { offset: 1, color: barColors[index][1] }
            ]
          }
        }
      }))
    }
  ]
};

  return (
    <Panel
      title="停车资源分布"
    >
      <ReactEcharts
        option={Option}
        style={{height: '200px', width: '420px'}}
        className='react_for_echarts'
      />
    </Panel>
  )
}

export default ParkikngResource
